<template>
  <div class="table_wrapper">
    <div class="table_scroll_head">
      <table class="table_list" :class="tableClass" ref="table">
        <slot name="header" :columnNum="columnNum"></slot>
      </table>
    </div>

    <div class="table_scroll_body" :style="{height: this.scrollHeight}" ref="scrollBody">
      <table class="table_list">
        <slot name="header" :columnNum="columnNum"></slot>
        <tbody class="table_list_body">
          <template v-if="currentList && currentList.length">
            <slot name="row" v-for="(rowData, index) in currentList" v-bind="{rowData, index, currentList}"></slot>
          </template>
          <template v-else>
            <tr><td :colspan="columnNum" class="center">{{emptyText}}</td></tr>
          </template>
        </tbody>
      </table>

      <div v-if="hasMoreItem" class="table_list_more">
        <button @click="currentPage = totalPagesNum - 1" class="btn">전체보기</button>
      </div>
    </div>

  </div>
</template>

<script>
import base from '$mixins/table/base'

export default {
  mixins: [ base ],
  props: {
    scrollHeight: {
      type: String,
      default: '350px'
    },
    itemPerPage: {
      type:Number,
      default: 200
    }
  },
  computed: {
    hasMoreItem() {
      if (_.isEmpty(this.clonedList)) return false
      return this.currentIndex < this.clonedList.length
    },
    currentIndex() {
      return this.itemPerPage * this.currentPage + this.itemPerPage
    },
    currentList() {
      if (_.isEmpty(this.clonedList)) return null
      return this.clonedList.slice(0, this.currentIndex)
    }
  },
  methods: {
    scrollTo(x, y) {
      this.$el.querySelector('.table_scroll_body').scrollTo(x, y);
    }
  }
}
</script>

<style>
.dataTables_scrollBody thead {
  display: none;
}
.dataTables_scrollBody {
  overflow-y: auto;
}
</style>
s
